<template>
  <div class="question-box">
    <div class="question-title">
      <h2 class="train-title">
        <span>实训{{index+1}}：</span>
        <span v-html="training_title"></span>
      </h2>
    </div>
    <div class="question-option-desc">
      <div class="train-title">
        <span>【实训简介:】</span>
        <span v-html="training_introduce"></span>
      </div>

    </div>
    <template v-if="training_url">
      <div v-for="(tr,idx) in training_url" class="question-train-url" :key="idx">
        <div class="question-option-video" v-if="jugeMaterialType(tr.name)==='video'">
          <video controls="controls" :src="tr.url"></video>
        </div>
        <div class="question-option-img" v-else-if="jugeMaterialType(tr.name)==='img'">
          <img :src="tr.url" />
        </div>
        <div class="question-option-app" v-else-if="jugeMaterialType(tr.name)==='word'">
          <p>教学文件：</p>
          <span></span><a :href="tr.url" :download="tr.name" target="_blank">{{tr.name}}</a>
        </div>
      </div>
    </template>
    <div class="question-option-material">
      <div class="download-menu">
        <i class="el-icon-download"></i> 参考资料
      </div>
      <div slot="tip" class="el-upload__tip" style="display: inline-block; ">（下载所需资料）</div>
      <ul>
        <li v-for="(item,i) in materials" :key="i">
          <span></span><a :href="item.url" :download="item.name" target="_blank">{{item.name}}</a>
        </li>
      </ul>
    </div>
    <el-divider></el-divider>
    <div class="question-option-material">
      <h2>实训工具</h2>
      <ul>
        <li v-for="(item,i) in training_tools" :key="i">
          <img :src="item.image" style="position:relative;top:8px;margin-right:5px;" />{{item.name}}
        </li>
      </ul>
    </div>
    <el-divider></el-divider>
    <div class="question-option-post">
      <h2>实训提交</h2>
      <el-input type="textarea" :rows="5" v-model="trainAnswer.content" placeholder="说点什么"></el-input>
      <el-upload class="upload-material" action="" :http-request="fnUploadRequest" name="files" :file-list="mFiles" list-type="text"
        :on-success="(res,file)=>handleMaterialsSuccess(res,file,'materials')" :on-remove="(file,fileList)=>handleFileRemove('materials',file, fileList)"
        :data="{filename: 'files'}" :before-upload="(file)=>beforeFileUpload('materials',file)" :limit="5" :on-exceed="cktips">
        <div>
          <el-button size="small" type="success">
            <i class="el-icon-upload2"></i>
            上传附件
          </el-button>
        </div>
      </el-upload>
    </div>

  </div>
</template>

<script>
import { userSubmitTopicData } from '@/api/show'
import oss from '@/utils/aliOss'
export default {
  created() {

  },
  beforeDestroy() {
    if (!this.status) {
      this.answerPost();
    }
  },
  watch: {
    currentIndex: function () {
      this.initData()
    }
  },
  props: ['itemContent', 'index', 'currentIndex', 'status', 'recordId', 'replay_type'],
  data() {
    return {
      trainAnswer: {
        content: '',
        file: []
      },
      titleId: '',//试题id
      training_title: '',
      training_introduce: '',
      training_url: [],
      materials: [],
      training_tools: [],
      showMore: false,//展示更多
      mFiles: [],//附件材料
    }
  },
  mounted() {
    this.initData()
    let answer = sessionStorage.getItem('answer')
    if (answer !== '') {
      answer = JSON.parse(answer)
      this.trainAnswer = answer
      this.mFiles = [...answer.file]
    }
    window.onbeforeunload = e => {
      if (this.$route.fullPath === "/show/exercise") {
        e = e || window.event;
        if (e) {
          e.returnValue = "关闭提示";
        }
        // return "关闭提示";
      } else {
        window.onbeforeunload = null
      }
    };
  },
  methods: {
    initData: function () {
      this.trainAnswer = {
        content: '',
        file: []
      }
      this.titleId = this.itemContent.id
      this.training_title = this.itemContent.training_title
      this.training_introduce = this.itemContent.training_introduce
      this.training_url = this.itemContent.training_url
      this.materials = this.itemContent.materials
      this.training_tools = this.itemContent.training_tool
    },
    /**
      * @description [fnUploadRequest 覆盖默认的上传行为，实现自定义上传]
      * @param    {object}   option [上传选项]
      * @return   {null}   [没有返回]
      */
    async fnUploadRequest(option) {
      oss.ossUploadFile(option, 3)
    },
    handleFileRemove(type, file, fileList) {
      this.trainAnswer.file.forEach((f, i) => {
        if (file.url) {
          if (f.url === file.url) {
            this.trainAnswer.file.splice(i, 1);
            return;
          }
        } else {
          if (f.url === file.response.res.requestUrls[0].split('?')[0]) {
            this.trainAnswer.file.splice(i, 1);
            return;
          }
        }
      })
    },
    // 素材资料的上传前钩子
    beforeFileUpload(type, file) {
      const imgs = ['png', 'jpg', 'jpeg', 'gif'];
      const suffix = file.name.substring(file.name.lastIndexOf('.') + 1)
      const result = this.common.beforeUploadImg(type, file);
      if (!result.success) {
        this.$message.error(result.msg)
        return false
      } else {
        if (imgs.indexOf(suffix) == -1) {
          return file;
        }
        let _this = this
        const isSize = new Promise(function (resolve, reject) {
          let _URL = window.URL || window.webkitURL;
          let img = new Image();
          img.onload = function () {
            let valid = img.width <= 4096 && img.height <= 4096;
            valid ? resolve() : reject();
          }
          img.src = _URL.createObjectURL(file);
        }).then(() => {
          return file;
        }, () => {
          _this.$message.error('上传文件的图片宽度或者高度不能超过4096像素')
          return Promise.reject();
        });
        return isSize
      }
    },
    // 素材资料文件上传成功的回调
    handleMaterialsSuccess(res, file, type = 'materials') {
      if (!res) return
      if (res.res.status === 200) {
        if (type === 'materials') {
          this.trainAnswer.file.push({
            name: file.name,
            url: res.res.requestUrls[0].split('?')[0]
          })
        }
      } else {
        this.$message.error('上传失败')
      }
    },
    cktips() {
      this.$message.warning(`参考资料限制上传5个文件`);
    },
    //判断教学材料类型，图片/视频/文件
    jugeMaterialType: function (name) {
      let imgArr = ['.jpg', '.jpeg', '.png', '.gif']
      let videoArr = ['.mp4']
      let type = ''
      for (let i = 0; i < imgArr.length; i++) {
        if (name.indexOf(imgArr[i]) > -1) {
          type = 'img'
        }
      }
      if (!type) {
        for (let j = 0; j < videoArr.length; j++) {
          if (name.indexOf(videoArr[j]) > -1) {
            type = 'video'
          }
        }
      }
      if (!type) {
        type = 'word'
      }
      return type
    },
    //提交答案
    answerPost: function () {
      let info = JSON.parse(sessionStorage.getItem('paperInfo'))
      let flag = true
      // if(this.trainAnswer.content===''&&this.trainAnswer.file.length===0){
      // 	flag = false
      // }
      if (flag) {
        let params = {
          student_id: info.studentId,
          competition_id: info.competitionId,
          paper_id: info.paperId,
          title_id: this.titleId,
          title_type: 9,
          answer: this.trainAnswer,
          record_id: this.recordId,
          replay_type: this.replay_type
        }
        userSubmitTopicData(params).then(response => {
          let obj = {
            type: 'train',
            index: this.index,
            currentIndex: this.currentIndex,
            answer: this.trainAnswer
          }
          this.$root.$emit('returnanswer', obj);
        })
      }

    }
  },
  filters: {
    capitalize: function (value) {
      if (!value && value != 0) return false;
      var arr = { 0: 'A', 1: 'B', 2: 'C', 3: 'D', 4: 'E', 5: 'F', 6: 'G', 7: 'H' }
      var str = '';
      for (var i = 0; i < value.length; i++) {
        str += ' ' + arr[value[i]] + ' '
      }
      return str
    },

  }
}
</script>

<style scoped>
</style>